module.exports = __webpack_public_path__ + "a360a36446cda31b7f7f77f9be325572.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/bangkokpost.png
// module id = 1371
// module chunks = 47